import { render, staticRenderFns } from "./ReservationsAttachments.vue?vue&type=template&id=e44275b0&lang=pug"
import script from "./ReservationsAttachments.vue?vue&type=script&lang=js"
export * from "./ReservationsAttachments.vue?vue&type=script&lang=js"
import style0 from "./ReservationsAttachments.vue?vue&type=style&index=0&id=e44275b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports